import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "conversation-wrapper"
}
const _hoisted_2 = { class: "conversation-body" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex h-100 bg-white justify-content-center flex-column text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "You're starting a new conversation", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Type your first message below.", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "messages-loading-overlay"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "loader-parent" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" })
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "conversation-input"
}
const _hoisted_11 = {
  key: 1,
  class: "d-flex h-100 bg-white justify-content-center flex-column text-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Welcome to Axxess Connect — your internal messaging solution.", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Start a conversation to share updates, ask questions, or connect with your team.", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Clear communication drives great teamwork—and this is where it happens. Stay connected anywhere.", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Download the Axxess Central Mobile App to message your team on the go.", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConversationHeader = _resolveComponent("ConversationHeader")!
  const _component_MessagesRenderer = _resolveComponent("MessagesRenderer")!
  const _component_ChatSummerEditor = _resolveComponent("ChatSummerEditor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.activeConversation?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("header", {
            class: _normalizeClass(`conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center ${
                _ctx.isCallOngoing ? 'active-call-header' : ''
            }`)
          }, [
            _createVNode(_component_ConversationHeader)
          ], 2 /* CLASS */),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.activeConversation?.isDraftConversation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : _createCommentVNode("v-if", true),
            (_ctx.showRepliedMsgLoader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_MessagesRenderer)
          ]),
          (_ctx.activeConversation?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(), _createBlock(_component_ChatSummerEditor, { key: _ctx.activeConversationId }))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!_ctx.activeConversation?.id && !_ctx.activeConversation?.isDraftConversation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_16))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}